
import React, { useEffect, useState } from "react";
import STF_CONSTANTS from "../../services/stfConstant.service";
import Storage from "../../services/storage.service";

export default function ProgressBar() {
    const [stepPercent, setStepPercent] = useState(0);
    const [totalSteps, setTotalSteps] = useState();
    const [category, setCategory] = useState(false);


    const percentageCounter = (data) => {
        setStepPercent(0);
        let stepsData = totalSteps;
        const totalStepsCount = totalSteps?.length;
        let stepPercentage = 100 / totalStepsCount;
        if (data && stepsData?.length) {
            if (data?.choose_topup_category === true && window.location.href.includes("confirmation")) {
                stepPercentage = stepPercentage * totalStepsCount
                setStepPercent(stepPercentage);
            } else if (data?.SIMActivated === true || data?.ActivationFailed === true) {
                stepPercentage = stepPercentage * totalStepsCount
                setStepPercent(stepPercentage);
            }
            else {
                stepsData.forEach(steps => {
                    if (steps?.stepName && steps?.stepName !== STF_CONSTANTS.PAYMENT_STEPS
                        && (data[steps?.stepName] === true || data[steps?.stepName] === false)) {
                        steps.stepVisited = data[steps?.stepName]
                        if (steps.stepVisited) {
                            setStepPercent((prev) => prev + stepPercentage);
                        }
                    }
                    if (steps?.stepNameOptional && (data[steps?.stepNameOptional] === true || data[steps?.stepNameOptional] === false)) {
                        steps.stepVisited = data[steps?.stepNameOptional]
                        if (steps.stepVisited) {
                            setStepPercent((prev) => prev + stepPercentage);
                        }
                    }
                });
                setTotalSteps(stepsData);
            }
        }
    }

    useEffect(() => {
        Storage.get_obsrv("flags").subscribe(data => {
            if (data) {
                percentageCounter(data)
            }
        });
    }, [category, totalSteps]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (Storage.get("choose_topup_category", true)) {
            setCategory(true);
            setTotalSteps(STF_CONSTANTS?.TOP_UP_PROGRESS_STEPS)
        } else {
            setCategory(false);
            setTotalSteps(STF_CONSTANTS?.PROGRESS_STEPS)
        }
    }, [Storage.get_obsrv("flags")])// eslint-disable-line react-hooks/exhaustive-deps

    return (stepPercent === 0 ? null : <div className={`stepperProgressBar ${stepPercent === 100 ? "full-loaded" : "partially-loaded"}`}>
        <div style={{ width: `${stepPercent}%` }}></div>
    </div>);
}